// Hook to extract guest access hash from pages without Router context
import { useGuestAccessHashBase } from './useGuestAccessHashBase';

export const useGuestAccessHashStandalone = (selector) => {
    const search = window.location?.search;
    return useGuestAccessHashBase(selector, search);
};
